import { Box, MenuItem, Button } from '@mui/material';
import {
  DialogTitle,
  CustomTextField,
  CustomSelect,
  HorizontalForm,
  VerticalForm,
} from '../../../common';
import { generateCUIT } from '../utils/subscribersUtils';

const PersonalDataSection = ({
  selectedSubscriber,
  onInputChange,
  onSelectChange,
  isMobile,
  nationalities,
  maritalStatuses,
}) => {
  const handleGenerateCUIT = () => {
    if (selectedSubscriber.dni && selectedSubscriber.gender) {
      const cuit = generateCUIT(selectedSubscriber.dni, selectedSubscriber.gender);
      onInputChange({
        target: {
          name: 'cuit',
          value: cuit,
        },
      });
    }
  };

  if (isMobile) {
    return (
      <Box>
        <DialogTitle showSeparator={false}>Datos Personales</DialogTitle>
        <VerticalForm>
          <CustomTextField
            label="Nombre"
            name="first_name"
            value={selectedSubscriber.first_name || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomTextField
            label="Apellido"
            name="last_name"
            value={selectedSubscriber.last_name || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomSelect
            label="Sexo"
            name="gender"
            value={selectedSubscriber.gender || ''}
            onChange={onSelectChange}
            size="medium"
          >
            <MenuItem value="h">Masculino</MenuItem>
            <MenuItem value="m">Femenino</MenuItem>
            <MenuItem value="O">Otro</MenuItem>
          </CustomSelect>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-end' }}>
            <CustomTextField
              label="DNI"
              name="dni"
              value={selectedSubscriber.dni || ''}
              onChange={onInputChange}
              size="medium"
              sx={{ flex: 1 }}
            />
            <Button
              variant="contained"
              size="small"
              onClick={handleGenerateCUIT}
              sx={{ height: '56px', minWidth: '60px' }}
            >
              →
            </Button>
          </Box>
          <CustomTextField
            label="CUIT"
            name="cuit"
            value={selectedSubscriber.cuit || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomTextField
            label="Fecha de Nacimiento"
            name="birth_date"
            type="date"
            value={selectedSubscriber.birth_date ? selectedSubscriber.birth_date.substr(0, 10) : ''}
            onChange={onInputChange}
            size="medium"
            shrinkLabel={true}
          />
          <CustomSelect
            label="Nacionalidad"
            name="uuid_nationality"
            value={selectedSubscriber.uuid_nationality || ''}
            onChange={onSelectChange}
            size="medium"
          >
            {nationalities.map((nat) => (
              <MenuItem key={nat.uuid} value={nat.uuid}>
                {nat.description}
              </MenuItem>
            ))}
          </CustomSelect>
          <CustomSelect
            label="Estado Civil"
            name="uuid_marital_status"
            value={selectedSubscriber.uuid_marital_status || ''}
            onChange={onSelectChange}
            size="medium"
          >
            {maritalStatuses.map((ms) => (
              <MenuItem key={ms.uuid} value={ms.uuid}>
                {ms.description}
              </MenuItem>
            ))}
          </CustomSelect>
        </VerticalForm>
      </Box>
    );
  }

  return (
    <Box>
      <DialogTitle showSeparator={false} sx={{ p: 0 }}>Datos Personales</DialogTitle>
      <HorizontalForm withBorder={false} sx={{ p: 1 }}>
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2, mr: 4 }}>
          <CustomTextField
            label="Nombre"
            name="first_name"
            value={selectedSubscriber.first_name || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomSelect
            label="Sexo"
            name="gender"
            value={selectedSubscriber.gender || ''}
            onChange={onSelectChange}
            size="medium"
          >
            <MenuItem value="h">Masculino</MenuItem>
            <MenuItem value="m">Femenino</MenuItem>
            <MenuItem value="O">Otro</MenuItem>
          </CustomSelect>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-end' }}>
            <CustomTextField
              label="DNI"
              name="dni"
              value={selectedSubscriber.dni || ''}
              onChange={onInputChange}
              size="medium"
              sx={{ flex: 1 }}
            />
            <Button
              variant="contained"
              size="small"
              onClick={handleGenerateCUIT}
              sx={{ height: '56px', minWidth: '60px' }}
            >
              →
            </Button>
          </Box>
          <CustomTextField
            label="Fecha de Nacimiento"
            name="birth_date"
            type="date"
            value={selectedSubscriber.birth_date ? selectedSubscriber.birth_date.substr(0, 10) : ''}
            onChange={onInputChange}
            size="medium"
            shrinkLabel={true}
          />
        </Box>
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <CustomTextField
            label="Apellido"
            name="last_name"
            value={selectedSubscriber.last_name || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomSelect
            label="Estado Civil"
            name="uuid_marital_status"
            value={selectedSubscriber.uuid_marital_status || ''}
            onChange={onSelectChange}
            size="medium"
          >
            {maritalStatuses.map((ms) => (
              <MenuItem key={ms.uuid} value={ms.uuid}>
                {ms.description}
              </MenuItem>
            ))}
          </CustomSelect>
          <CustomTextField
            label="CUIT"
            name="cuit"
            value={selectedSubscriber.cuit || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomSelect
            label="Nacionalidad"
            name="uuid_nationality"
            value={selectedSubscriber.uuid_nationality || ''}
            onChange={onSelectChange}
            size="medium"
          >
            {nationalities.map((nat) => (
              <MenuItem key={nat.uuid} value={nat.uuid}>
                {nat.description}
              </MenuItem>
            ))}
          </CustomSelect>
        </Box>
      </HorizontalForm>
    </Box>
  );
};

export default PersonalDataSection;
